module.exports = __webpack_public_path__ + "assets/images/23-38YQmnK.jpg";